import fetch from '@/utils/fetch';
import * as API from '@/commons/http-api';
import { getUserAgent } from '@/utils/index';

export default {
  namespace: 'knowLedgeHome',
  state: {
    dataSource: [],
    infoList: [],
    courseList: [],
    standardList: [],
    bannerList: [],
    loading: false,
  },
  reducers: {
    setDataSource(state, action) {
      return {
        ...state,
        dataSource: action.payload,
        loading: false,
      };
    },
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    setInfoList(state, action) {
      const { records } = action.payload;
      const infoList = records.slice(0, 3);
      return {
        ...state,
        infoList,
        loading: false,
      };
    },
    setCourseList(state, action) {
      const { records } = action.payload;
      const courseList = records.slice(0, 3);
      return {
        ...state,
        courseList,
        loading: false,
      };
    },
    setStandardList(state, action) {
      const { records } = action.payload;
      const standardList = records.slice(0, 5);
      return {
        ...state,
        standardList,
        loading: false,
      };
    },
    setBannerList(state, action) {
      return {
        ...state,
        bannerList: action.payload,
        loading: false,
      };
    },
  },
  effects: {
    *getDataSource(action, { put }) {
      const { callback = () => {} } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {};
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_LABEL, params);
      yield put({
        type: 'setDataSource',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback(res);
      }
    },
    *getInfoByLabel(action, { put }) {
      const { labelId, callback = () => {} } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {
        labelId,
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_INFO, params);
      yield put({
        type: 'setInfoList',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    *getCourseByLabel(action, { put }) {
      const { labelId, callback = () => {} } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {
        labelId,
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_INFO, params);
      yield put({
        type: 'setCourseList',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    *getStandardByLabel(action, { put }) {
      const { labelId, callback = () => {} } = action.payload;
      yield put({
        type: 'setLoading',
        payload: true,
      });
      let params = {
        labelId,
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['appVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_INFO, params);
      yield put({
        type: 'setStandardList',
        payload: res.data && res.data,
      });
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
    *getBannerList(action, { put }) {
      let params = {
        location: '00',
      };
      const UA = getUserAgent();
      if (UA.IsAndroid) {
        params['platform'] = 'ANDROID';
      } else if (UA.IsIOS) {
        params['platform'] = 'IOS';
      }
      if (window.sessionStorage['xlm-version']) {
        params['supportVersion'] = window.sessionStorage['xlm-version'];
      }
      const res = yield fetch.post(API.KNOWLEDGE_GET_BANNER, params);
      console.log(res);
      yield put({
        type: 'setBannerList',
        payload: res.data,
      });
    },
    *getInfoClick(action, { put }) {
      const { id } = action.payload;
      yield fetch.get(API.KNOWLEDGE_SUM_CLICK, { id });
    },
  },
};
